import { gql } from '@apollo/client';

/* ── interactive stock research sessions (the analyst agent) ─────────────── */

/* A session is opened — and the analyst reached — through the web token,
   createLivekitTokenStockResearchInstitutionalWeb (mutations/livekit.js),
   in the assistant's chat; these are what the session tab runs on it. */

/**
 * Runs an action the analyst proposed in chat (finalise / publish /
 * save_trade_thesis / apply_assumptions). The agent never runs these itself —
 * this is the only path that does, with the one-time token from the stream.
 */
export const CONFIRM_STOCK_ANALYST_ACTION = gql`
  mutation ConfirmStockAnalystAction($sessionId: Int!, $pendingActionId: Int!, $confirmationToken: String!) {
    confirmStockAnalystAction(sessionId: $sessionId, pendingActionId: $pendingActionId, confirmationToken: $confirmationToken) {
      pendingActionId
      action
      status
      result
    }
  }
`;

/** A fresh one-time token for a proposal — how a card proposed in a voice call (which carries none) is approved. */
export const ISSUE_STOCK_ANALYST_TOKEN = gql`
  mutation IssueStockAnalystConfirmationToken($sessionId: Int!, $pendingActionId: Int!) {
    issueStockAnalystConfirmationToken(sessionId: $sessionId, pendingActionId: $pendingActionId) {
      pendingActionId
      confirmationToken
    }
  }
`;

/** Declines a proposed action; the note is stored with it. */
export const REJECT_STOCK_ANALYST_ACTION = gql`
  mutation RejectStockAnalystAction($sessionId: Int!, $pendingActionId: Int!, $note: String) {
    rejectStockAnalystAction(sessionId: $sessionId, pendingActionId: $pendingActionId, note: $note) {
      pendingActionId
      action
      status
      result
    }
  }
`;

/**
 * Ends a session — finalised or not. Its revisions stay readable; the chat
 * and the proposed actions are closed with it.
 */
export const CLOSE_STOCK_ANALYST_SESSION = gql`
  mutation CloseStockAnalystSession($sessionId: Int!) {
    closeStockAnalystSession(sessionId: $sessionId) {
      id
      securitySymbol
      status
      finalRevisionId
      companyReportId
      updatedAt
    }
  }
`;

/** A presigned link to the revision's PDF — rendered on the first request, so that one is slower. */
export const DOWNLOAD_STOCK_ANALYST_REPORT = gql`
  mutation DownloadStockAnalystReport($revisionId: Int!) {
    downloadStockAnalystReport(revisionId: $revisionId) {
      revisionId
      s3Key
      url
    }
  }
`;
